import axios from 'axios';
import config from '../../config';
import { authHeader } from '../../helpers';

export const addLibraryCategory = async (body) => {
  const response = await axios.post(
    `${config.API_URL}/library/category`,
    body,
    {
      headers: authHeader(),
    },
  );
  return response.data;
};

export const getAllCategory = async (params) => {
  const response = await axios.get(`${config.API_URL}/library/categories`, {
    params,
    headers: authHeader(),
  });
  return response.data;
};

export const getCategoryById = async (categoryId) => {
  const response = await axios.get(
    `${config.API_URL}/library/category/${categoryId}`,
    { headers: authHeader() },
  );
  return response.data;
};

export const getPublishCategoriesByType = async (envType) => {
  const response = await axios.get(
    `${config.API_URL}/library/categories/public/${envType}`,
    {
      headers: authHeader(),
    },
  );
  return response.data;
};

export const deleteFlexCategory = async (id) => {
  const response = await axios.delete(
    `${config.API_URL}/library/category/${id}`,
    {
      headers: authHeader(),
    },
  );
  return response.data;
};

export const uploadImageContent = async (formData) => {
  const response = await axios.post(
    `${config.API_URL}/library/image/upload`,
    formData,
    { headers: authHeader() },
  );
  return response.data;
};

export const updateCategory = async (id, data) => {
  const response = await axios.put(
    `${config.API_URL}/library/category/${id}`,
    data,
    {
      headers: authHeader(),
    },
  );
  return response.data;
};

export const getFlexCategoriesOrder = async (params) => {
  const response = await axios.get(
    `${config.API_URL}/library/categories/order`,
    {
      params,
      headers: authHeader(),
    },
  );
  return response.data;
};

export const updateOrderCategory = async (orderList) => {
  const response = await axios.put(
    `${config.API_URL}/library/category/order`,
    { orderList },
    {
      headers: authHeader(),
    },
  );
  return response.data;
};

// export const getAllCategory = async (query) => {
//   const response = await axios.get(`${config.API_URL}/library/categories`, {
//     query
//   });
//   return response.data;
// };
